'use client';
import {
  documentPlaceholder,
  isCnpj,
  isCpf,
  isPassport
} from '@payments-checkout/shared/helpers/constants/document-person-type.const';
import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { InputField, InputFieldProps, MaskedInput } from '@stone-payments/jade';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { CustomerFields } from '../../app/types/customerInformation.types';

export function DocumentInput({
  documentType,
  disabled = false,
  ...props
}: { documentType: string; disabled?: boolean } & Omit<
  InputFieldProps,
  'label'
>) {
  const intl = useIntl();
  const {
    register,
    setError,
    formState: { errors },
  } = useFormContext<CustomerFields>();

  const trackDocumentFilled = (event: { target: { value: string } }) => {
    if (event.target.value) {
      analiticaInstance.events.homePage.formFieldFilled('campo_documento');
    }
  };

  return (
    <>
      {isPassport(documentType) && (
        <InputField
          {...register('passport', {
            onChange(e) {
              setError('passport', {});
              const value = e.target.value
                .replace(/[^a-zA-Z0-9]/g, '')
                .toLocaleUpperCase();
              e.target.value = value;
            },
            onBlur: trackDocumentFilled,
          })}
          label={
            intl.formatMessage({ id: 'customerForm.documentNumber' }) + ' *'
          }
          size="medium"
          placeholder={documentPlaceholder.passport}
          error={!!errors.passport?.message}
          disabled={disabled}
          supportText={
            errors.passport?.message &&
            intl.formatMessage({
              id: `customerForm.validate.${errors.passport?.message}`,
            })
          }
          autoFocus={props.autoFocus}
        />
      )}
      {isCpf(documentType) && (
        <MaskedInput
          autoFocus={props.autoFocus}
          key={documentType}
          label={
            intl.formatMessage({ id: 'customerForm.documentNumber' }) + ' *'
          }
          size="medium"
          type="text"
          inputMode="numeric"
          placeholder={documentPlaceholder.CPF}
          mask="cpf"
          error={!!errors.cpf?.message}
          disabled={disabled}
          supportText={
            errors.cpf?.message &&
            intl.formatMessage({
              id: `customerForm.validate.${errors.cpf?.message}`,
            })
          }
          {...register('cpf', { onBlur: trackDocumentFilled })}
        />
      )}
      {isCnpj(documentType) && (
        <MaskedInput
          autoFocus={props.autoFocus}
          key={documentType}
          label={
            intl.formatMessage({ id: 'customerForm.documentNumber' }) + ' *'
          }
          size="medium"
          type="text"
          inputMode="text"
          placeholder={documentPlaceholder.CNPJ}
          mask="cnpj"
          error={!!errors.cnpj?.message}
          disabled={disabled}
          supportText={
            errors.cnpj?.message &&
            intl.formatMessage({
              id: `customerForm.validate.${errors.cnpj?.message}`,
            })
          }
          {...register('cnpj', {
            onChange(e) {
              e.target.value = e.target.value.toUpperCase();
            },
            onBlur: trackDocumentFilled,
          })}
        />
      )}
    </>
  );
}
